"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _constants = require("composer-lib/lib/constants");

var _default = (0, _createReactClass.default)({
  displayName: "MaxLengthWarning",
  mixins: [_reactAddonsPureRenderMixin.default],
  propTypes: {
    className: _propTypes.default.string,
    value: _propTypes.default.string.isRequired,
    maxLength: _propTypes.default.number.isRequired,
    maxLengthWarningThreshold: _propTypes.default.number
  },
  getDefaultProps: function getDefaultProps() {
    return {
      maxLengthWarningThreshold: _constants.MAX_LENGTH_WARNING_THRESHOLD
    };
  },
  getLangKey: function getLangKey(count) {
    var langPrefix = 'composer-lib.composer.maxLengthWarning';

    if (count === 0) {
      return langPrefix + ".zeroRemainingCharacters";
    }

    return langPrefix + ".remainingCharacters";
  },
  render: function render() {
    var _this$props = this.props,
        className = _this$props.className,
        value = _this$props.value,
        maxLength = _this$props.maxLength,
        maxLengthWarningThreshold = _this$props.maxLengthWarningThreshold;
    var remainingCharacters = maxLength - value.length;
    var classes = (0, _classnames.default)('composer-max-length-warning', className);

    if (remainingCharacters <= maxLengthWarningThreshold) {
      return _react.default.createElement("div", {
        className: classes
      }, _react.default.createElement(_FormattedMessage.default, {
        message: this.getLangKey(remainingCharacters),
        options: {
          count: remainingCharacters
        }
      }));
    }

    return null;
  }
});

exports.default = _default;
module.exports = exports.default;